import { render, staticRenderFns } from "./querysms.vue?vue&type=template&id=33323848"
import script from "./querysms.vue?vue&type=script&lang=js"
export * from "./querysms.vue?vue&type=script&lang=js"
import style0 from "./querysms.vue?vue&type=style&index=0&id=33323848&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports